import { useEffect } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export const FaqSection = ({ faqs, title = 'Häufige Fragen', dark = false, lang = 'de-CH' }) => {
  useEffect(() => {
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      inLanguage: lang,
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => script.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  return (
    <section className={`py-20 px-6 ${dark ? 'bg-slate-950' : 'bg-slate-50'}`} data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <h2 className={`text-base md:text-lg font-bold mb-8 ${dark ? 'text-white' : 'text-slate-900'}`}>
          {title}
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className={dark ? 'border-white/10' : 'border-slate-200'}
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className={`text-left text-sm md:text-base font-medium ${dark ? 'text-slate-200 hover:text-teal-400' : 'text-slate-800 hover:text-teal-600'}`}
                data-testid={`faq-trigger-${i}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className={`text-sm leading-relaxed ${dark ? 'text-slate-400' : 'text-slate-600'}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
